module.exports = __webpack_public_path__ + "static/media/sidebar-3.c958a453.jpg";